import { render, staticRenderFns } from "./miniNewsItem.vue?vue&type=template&id=1013a37c&"
import script from "./miniNewsItem.vue?vue&type=script&lang=js&"
export * from "./miniNewsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports